import { render } from "./ImportExcelData.vue?vue&type=template&id=64ea3d42&bindings={}"
import script from "./ImportExcelData.vue?vue&type=script&lang=ts"
export * from "./ImportExcelData.vue?vue&type=script&lang=ts"

import "./ImportExcelData.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script